<template>
    <el-dialog :append-to-body="true" id="add-personal-layer" :title="add?'添加人员':'修改'" :visible.sync="dialogVisible" width="506px" :center="true">
      <p v-show="add" class="dialog-tip">请填写真实姓名，并且确认对方方姓名及电话信息准确，若信息不准确可能导致无法加入企业</p>
      <el-form @submit.native.prevent :model="personalForm" :rules="personalRules" ref="personalForm" label-width="70px" class="personal-Form">
        <el-form-item prop="name" label="姓名">
          <el-input v-model="personalForm.name" maxlength="30" :disabled="!add" placeholder="请输入姓名" style="width: 334px;"></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="手机号">
          <el-input v-model="personalForm.phone" maxlength="11" :disabled="!add" placeholder="请输入手机号" style="width: 334px;"></el-input>
        </el-form-item>
        <el-form-item prop="position" label="职位">
          <el-input v-model="personalForm.position" maxlength="30" placeholder="请输入职位" style="width: 334px;"></el-input>
        </el-form-item>
      </el-form>

      <div class="dialog-btns">
        <el-button type="primary" @click="addPersonal" class="btn-ok">确认</el-button>
        <el-button type="info" @click="cancel" class="btn-cancel">取消</el-button>
      </div>
    </el-dialog>
</template>
<script>
import { addPersonalApi, editPersonalApi } from '@/api/space/personal-management'
import { mapState } from 'vuex'
export default {
  computed: mapState([
    'currentSpace'
  ]),
  props: ['add', 'rowId'],
  data() {
    // 校验手机号格式
    var checkPhone = (rule, value, callback) => {
      var phoneReg = /^1[3456789]\d{9}$/;
      if (!phoneReg.test(value)) {
        callback(new Error('请输入正确手机号！'));
      } else {
        callback();
      }
    }

    var checkChinese = (rule, value, callback) => {
      var reg = /^[\u0391-\uFFE5]+$/;
      if (!reg.test(value)) {
        callback(new Error('只能输入中文！'))
      } else {
        callback();
      }
    }

    return {
      dialogVisible: false,
      personalForm: {
        name: '',
        phone: '',
        position: ''
      },
      personalRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          {validator: checkChinese, trigger: 'blur'}
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {validator: checkPhone, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    addPersonal() {
      if (this.add) {
        this.$refs.personalForm.validate((valid) => {
          if (valid) {
            addPersonalApi({
              companyId: this.currentSpace.companyId,
              name: this.personalForm.name,
              phone: this.personalForm.phone,
              position: this.personalForm.position
            }).then(res => {
              if (res.code !== 200) {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'warning'
                });
              } else {
                this.$message({
                  showClose: true,
                  message: '已发送邀请！',
                  type: 'success'
                });
                this.cancel()
                this.$parent.init()
              }
            }).catch(err => {
              console.log(err)
            })
          } else {
            // this.$message.warning(`姓名或手机号不能为空！`);
          }
        })
      } else {
        editPersonalApi({
          companyId: this.currentSpace.companyId,
          id: this.rowId,
          position: this.personalForm.position
        }).then(res => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning'
            });
          } else {

            this.cancel()
            this.$parent.init()
          }
        }).catch(err => {
          console.log(err)
        })
      }
      
    },
    cancel() {
      this.personalForm.name = ''
      this.personalForm.phone = ''
      this.personalForm.position = ''
      this.dialogVisible = false
    }
  }
}
</script>
<style>

  .personal-Form input{
    height: 48px;
  }

  .personal-Form .el-form-item__label{
    height: 48px;
    line-height: 48px;
  }
</style>
<style scoped>
  .dialog-tip{
    font-size: 14px;
    color: #E85052;
    width: 375px;
    margin-left: 54px;
  }

  .personal-Form{
    width: 405px;
    margin: 28px auto 0;
  }

  .dialog-btns{
    width: 405px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
  }

  .dialog-btns button {
    display: block;
    width: 179px;
    height: 50px;
    font-size: 18px;
    border-radius: 10px;
  }
  
</style>